import plur from 'plur'
import * as React from 'react'

import FilterInput from './FilterInput/FilterInput'

import styles from './CompareBuildsFilter.css'

type Props = {
  type: string | null | undefined
  className?: string | null | undefined
  filterText: string
  changeFilterText: (arg0: string) => unknown
  resultsCount: number
  resultsLimited: boolean
}

function CompareBuildsFilter({
  type,
  className,
  filterText,
  changeFilterText,
  resultsCount,
  resultsLimited,
}: Props) {
  let filter

  switch (type) {
    case 'tests':
      filter = 'Filter by test name'
      break

    case 'params':
    case 'statistics':
      filter = 'Filter by parameter name'
      break

    default:
      return null
  }

  return (
    <>
      <FilterInput
        filterText={filterText}
        changeFilterText={changeFilterText}
        placeholder={filter}
        className={className}
        timeout={800}
      />
      <span className={styles.found}>
        {filterText.length > 0 &&
          resultsCount > 0 &&
          `Found ${resultsLimited ? 'more than ' : ' '}${
            resultsLimited ? resultsCount - 1 : resultsCount
          } ${plur('item', resultsCount)}`}
      </span>
    </>
  )
}

export default CompareBuildsFilter
